@if (!(isPhonePortrait$ | async)) {
  <div class="computer">
    <div class="photo">
      <img
        [src]="
          productInPackageId
            | productInPackagePhoto: packageId
            | async
            | publicImageUrl: 400 : 400
            | async
        "
      />
    </div>
    <div class="information">
      <div class="border"></div>
      <ng-container *ngTemplateOutlet="information"></ng-container>
      <div class="buttons">
        @if (
          images.imagesRequired &&
          images.requiredImages.min <
            photosSelectedByPhotographer?.photos.length
        ) {
          <lib-button
            (click)="addMissingPhotos()"
            lg
            forceContext="productFront"
            translate
          >
            clhrmtvdu000008ms5f0a0b36
          </lib-button>
        }
        @if (!swap) {
          <lib-button
            (click)="addToBasket()"
            lg
            forceContext="productFront"
            translate
          >
            clhrdulje000008mqel629la6
          </lib-button>
        }
        @if (swap) {
          <lib-button
            (click)="swapToBasket()"
            lg
            forceContext="productFront"
            translate
          >
            clhrduqrj000108mqerma9y8b
          </lib-button>
        }
      </div>
    </div>
  </div>
}
@if (isPhonePortrait$ | async) {
  <div class="phone">
    <img
      [src]="
        productInPackageId
          | productInPackagePhoto: packageId
          | async
          | publicImageUrl: 400 : 400
          | async
      "
      class="photo"
    />
    <div class="information">
      <ng-container *ngTemplateOutlet="information"></ng-container>
    </div>
    <div class="buttons">
      <lib-button (click)="hideDialog.emit()" forceContext="common" translate
        >comeBack</lib-button
      >
      @if (
        images.imagesRequired &&
        images.requiredImages.min < photosSelectedByPhotographer?.photos.length
      ) {
        <lib-button
          (click)="addMissingPhotos()"
          forceContext="productFront"
          translate
          >clhrmtvdu000008ms5f0a0b36
        </lib-button>
      }
      @if (!swap) {
        <lib-button
          (click)="addToBasket()"
          forceContext="productFront"
          translate
          >clhrmu4yi000108ms92t016d2</lib-button
        >
      }
      @if (swap) {
        <lib-button
          (click)="swapToBasket()"
          forceContext="productFront"
          translate
          >clhrmu90v000208ms6kagfkzw</lib-button
        >
      }
    </div>
  </div>
}

<ng-template #information>
  <div class="allList">
    <h1>{{ product.name }}</h1>
    @for (item of filtered; track item) {
      <ng-container [formGroup]="model">
        <div class="list">
          @let itemType = item.type;

          @switch (itemType) {
            @case ('list') {
              <div [zalamoTooltip]="item.description | langPicker | async">
                {{ item.label | langPicker | async }}:
                {{ item | oneTextFromList: model.value }}
              </div>
            }
            @case ('decoration') {
              <div [zalamoTooltip]="item.description | langPicker | async">
                {{ item.label | langPicker | async }}:
                {{ item | oneTextFromList: model.value }}
              </div>
            }
            @case ('size') {
              <div [zalamoTooltip]="item.description | langPicker | async">
                {{ item.label | langPicker | async }}:
                {{ item | oneTextFromList: model.value }}
              </div>
            }
            @case ('boolean') {
              <div>
                <div class="check">
                  @if (item | checkedOrUnchecked: model.value) {
                    <mat-icon>check_circle </mat-icon>
                  }
                  @if (!(item | checkedOrUnchecked: model.value)) {
                    <mat-icon>cancel </mat-icon>
                  }
                  {{ item.label[0].text }}
                </div>
              </div>
            }
          }

          @if (item.type === 'counter') {
            <mat-form-field libZalamoField>
              <mat-label>{{ item.label | langPicker | async }}</mat-label>
              <input
                [formControlName]="item.customId"
                [max]="item.counterConfig.max"
                [min]="item.counterConfig.min"
                matInput
                type="number" />
              <mat-hint>
                <span translate>clhrodz1e000008mpbi4k0l20</span>&nbsp;
                <strong>{{ item.counterConfig.min }}</strong
                >&nbsp;
                <span
                  translate
                  [params]="{
                    min: item.counterConfig.min,
                    max: item.counterConfig.max,
                  }"
                  >clhroei0v000108mp7htk4nak</span
                >&nbsp;
                <strong>{{ item.counterConfig.max }}</strong>
              </mat-hint>
              <lib-zalamo-field-decoration></lib-zalamo-field-decoration
            ></mat-form-field>
          }

          @switch (itemType) {
            @case ('text') {
              <mat-form-field libZalamoField>
                <mat-label>{{ item.label | langPicker | async }}</mat-label>
                <textarea
                  [formControlName]="item.customId"
                  [maxLength]="item.textConfig.max"
                  [minLength]="item.textConfig.min"
                  matInput
                ></textarea>
                <mat-hint>
                  <span translate>clhss8ao8000008l05m7s2qrz</span>&nbsp;
                  <strong>{{ item.textConfig.min }}</strong
                  >&nbsp;
                  <span
                    translate
                    [params]="{
                      min: item.counterConfig.min,
                      max: item.counterConfig.max,
                    }"
                    >clhroei0v000108mp7htk4nak</span
                  >&nbsp;
                  <strong>{{ item.textConfig.max }}</strong>
                </mat-hint>
                <lib-zalamo-field-decoration></lib-zalamo-field-decoration
              ></mat-form-field>
            }
          }
        </div>
      </ng-container>
    }
    @if (
      images.imagesRequired &&
      images.requiredImages.min < photosSelectedByPhotographer.photos.length
    ) {
      <h2>
        <span translate>clhosif6t000008lb16oi9aqy</span>:
        @if (images.requiredImages.min !== images.requiredImages.max) {
          <span translate>clhosyo3h000208msg4bdenyp</span>
        }
        {{ images.requiredImages.min }}
        @if (images.requiredImages.min !== images.requiredImages.max) {
          <span translate>clhosj3zm000208lb8eqgbzn5</span>
          {{ images.requiredImages.max }}
        }
      </h2>
    }
    <!--    <h2 *ngIf="!inPackage">-->
    <!--      Maksymalna liczba produktów tego typu do dodaniania: {{ max }}-->
    <!--    </h2>-->
    <!--    <h2 *ngIf="inPackage">-->
    <!--      Liczba sztuk produktu tego typu do dodaniania: {{ max }}-->
    <!--    </h2>-->
    @if (!inPackage) {
      <app-change-number
        (newNumber)="currentNumber = $event"
        [maxNumber]="999"
        [minNumber]="0"
        [number]="quantity"
      >
      </app-change-number>
    }
  </div>
</ng-template>

<ng-template #messageAboutNoPhotosToBeAdded>
  <div class="message">
    <div>
      <h2>
        Musisz skompletować resztę pakietu żeby móc dodać zdjęcia do produktu
      </h2>
      <p>
        <lib-button
          (click)="closeDialog$.next()"
          lg
          forceContext="common"
          translate
          >close</lib-button
        >
      </p>
    </div>
  </div>
</ng-template>
